export default "__VITE_ASSET__d6Uu4lWb__"